import { User } from '@unified-commerce/gpc-vue-storefront-shopify';

import type { SimpleMenuLink } from '../types';

export const getAccountMenuItems = (user: User, content: any) =>
  (content.account ?? []).filter((item: SimpleMenuLink) =>
    user?.token
      ? item.link_text !== 'Sign In' && item.link_text !== 'Sign Up'
      : item.link_text !== 'Manage Account',
  );
